import { OnScreenModal } from '@components/ui/OnScreenModal'

export function PaymentFormNameModal({
  isOpen,
  onClose,
}: {
  isOpen: boolean
  onClose: () => void
}) {
  return (
    <OnScreenModal isOpen={isOpen} title="Why can't I change my name?" onClose={onClose}>
      <p className="text-sm text-gray-700">
        The first and last name of your payment information should match your application
        information. If you do not have a card in your name, please contact customer service at{' '}
        <a href="mailto:help@libertyrent.com" className="text-blue-600 hover:text-blue-800">
          help@libertyrent.com
        </a>{' '}
        or{' '}
        <a href="tel:8775817368" className="text-blue-600 hover:text-blue-800">
          (877) 581-7368
        </a>
        .
      </p>
      <div className="mt-4 flex justify-center">
        <button
          type="button"
          onClick={onClose}
          className="px-6 py-2 bg-blue-600 text-white text-sm font-medium rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
        >
          OK
        </button>
      </div>
    </OnScreenModal>
  )
}
